module.exports = __webpack_public_path__ + "img/bottom-bg.00da9856.png";